import { SurveyQuestionResponseStatistics } from '@occc/graphql';
import { buildBarChartTooltipSurveyRangedItems } from './buildBarChartTooltipSurveyRangedItems';
import { BuildSelectedRangeTooltipProps } from '../../../../design-system/components/BarChart/buildRenderTooltip';

export const buildSelectedRangeTooltipProps: BuildSelectedRangeTooltipProps<
  SurveyQuestionResponseStatistics['sliderResponseRanges'][0]
> = ({ items, selectedIndexes, totalValue }) => {
  if (selectedIndexes.length === 0) {
    return null;
  }

  const sum = selectedIndexes.reduce((acc, index) => acc + items[index].value, 0);

  const minIndex = Math.min(...selectedIndexes);
  const maxIndex = Math.max(...selectedIndexes);

  const range = `${items[minIndex].rawItem?.rangeStart} - ${items[maxIndex].rawItem?.rangeEnd}`;

  const percentage = (sum / totalValue) * 100;

  return {
    items: buildBarChartTooltipSurveyRangedItems({ range, sum, percentage }),
  };
};
